import axios from 'axios'

const http = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API
})

const state = {
    locationId: null,
    categoryId: null,
    deviceId: localStorage.getItem('deviceId') || null,
    score: null,
    comment: null
}

const getters = {
    getLocationId: state => state.locationId,
    getDeviceId: state => state.deviceId,
    getCategoryId: state => state.categoryId,
    getScore: state => state.score,
    getComment: state => state.comment,
    isFeedbackCompleted: state => (!!state.locationId && !!state.deviceId && !!state.score)
}

const actions = {
    submitFeedback: (({ state }) => {
        console.log(state)
        return http({
            method: "post",
            url: `/feedbacks/`,
            data: {
                "score": state.score,
                "location_id": state.locationId,
                "device_id": state.deviceId,
                "comment": state.comment
              }
        }).then(response => {
            console.log(response)
        }).catch(error => {
            console.log(error)
        }).finally(() => {
            state.locationId = null
            state.deviceId = null
            state.score = null
            state.comment = null
        })
    })
}

const mutations = {
    setLocationId: (state, id) => {
        state.locationId = id
    },
    setCategoryId: (state, id) => {
        state.categoryId = id
    },
    setDeviceId: (state, id) => {
        state.deviceId = id
    },
    setComment: (state, comment) => {
        state.comment = comment
    },
    setScore: (state, score) => {
        state.score = score
    },
    reset: (state) => {
        state.locationId = null
        state.deviceId = localStorage.getItem('deviceId') || null
        state.score = null
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
